export default __webpack_public_path__ + "static/media/scrap.44ca796a.svg";